/**
 * Whether the runtime recognizes a timezone code, so date formatting in that zone will not throw.
 *
 * @param timezoneCode The IANA timezone code to check, such as `America/New_York`.
 * @returns True when `Intl` accepts the code as a time zone.
 */
export function isValidTimezone(timezoneCode: string | undefined): boolean {
  if (!timezoneCode) return false;
  try {
    new Intl.DateTimeFormat("en-US", { timeZone: timezoneCode });
    return true;
  } catch {
    return false;
  }
}
